import React from 'react';
import cn from 'classnames';
import { ProductTileProps } from "../../../ProductTile/types";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import styles from './ProductPromotionMarker.module.scss';
const ProductPromotionMarker = ({ legalText, showPriceMarker, promotionalMarkerText, redPrice, discountPercentage, optimizelyClasses, }) => {
    var _a;
    const formatedDiscountPercentage = typeof discountPercentage === 'string' ? discountPercentage : `-${discountPercentage}%`;
    return ((_a = discountPercentage !== null && discountPercentage !== void 0 ? discountPercentage : showPriceMarker) !== null && _a !== void 0 ? _a : promotionalMarkerText) ? (React.createElement("div", { className: discountPercentage ? styles.percentageMarker : styles.promotionMarker },
        legalText && !discountPercentage && (React.createElement(MetaText, { className: styles.toolTipText }, legalText)),
        React.createElement(BodyText, { Tag: "span", className: cn(!discountPercentage &&
                `${optimizelyClasses === null || optimizelyClasses === void 0 ? void 0 : optimizelyClasses.PROMOTION_MARKER} ${styles.promotionMarkerText}`, discountPercentage && (optimizelyClasses === null || optimizelyClasses === void 0 ? void 0 : optimizelyClasses.PERCENTAGE_MARKER)) }, discountPercentage
            ? formatedDiscountPercentage
            : showPriceMarker
                ? redPrice
                : promotionalMarkerText))) : null;
};
export default ProductPromotionMarker;
//# sourceMappingURL=ProductPromotionMarker.js.map